<template>
  <main class="container-fluid bg-cover bg-registration">
    <b-alert class="m-4" show v-if="missingParameters" variant="danger">
      {{ $t("externalRequest.messages.missingParameters") }}
    </b-alert>

    <template v-if="!missingParameters">
      <border-layout>
        <h3 slot="header" class="pt-2 text-white text-shadow-primary">
          {{ $t("menu.externalProviderRegistrationRequest") }}
        </h3>

        <scrollable class="h-100">
          <b-card no-body class="opaque-90">
            <b-tabs
              card
              justified
              pills
              nav-wrapper-class="bg-transparent scrollable"
            >
              <!--
              ==================================================================
              Provider's data
              ==================================================================
              -->
              <b-tab>
                <template slot="title">
                  {{ $t("externalRequest.tabs.provider") }}
                  <b-badge
                    variant="danger"
                    v-if="$refs.providerForm && $refs.providerForm.errorCounter"
                  >
                    {{ $refs.providerForm.errorCounter }}
                  </b-badge>
                </template>
                <provider-registration-request-form
                  ref="providerForm"
                  v-model="instance"
                  :errors="validationErrors"
                ></provider-registration-request-form>
              </b-tab>
              <!--
              ==================================================================
              User's data
              ==================================================================
              -->
              <b-tab>
                <template slot="title">
                  {{ $t("externalRequest.tabs.user") }}
                  <b-badge
                    variant="danger"
                    v-if="$refs.userForm && $refs.userForm.errorCounter"
                  >
                    {{ $refs.userForm.errorCounter }}
                  </b-badge>
                </template>
                <user-form
                  ref="userForm"
                  v-model="instance"
                  :errors="validationErrors"
                ></user-form>
              </b-tab>
            </b-tabs>
          </b-card>
        </scrollable>
        <div slot="footer" class="buttons text-right py-2">
          <b-button variant="primary" @click.prevent="submit()">
            {{ $t("common.submit") }}
          </b-button>
        </div>
      </border-layout>
    </template>
  </main>
</template>
<script>
import BaseRequestMixin from "@/public/mixins/BaseRequestMixin";
import ProviderRegistrationRequestForm from "./ProviderRegistrationRequestForm";
import service from "./ProviderRegistrationRequestService";

export default {
  mixins: [BaseRequestMixin],

  components: {
    ProviderRegistrationRequestForm
  },

  methods: {
    getService() {
      return service;
    },

    resetAllErrorCounters() {
      this.$refs.providerForm.resetErrorCounter();
      this.$refs.userForm.resetErrorCounter();
    }
  }
};
</script>
